export var QueryStatus;
(function (QueryStatus) {
    QueryStatus["IDLE"] = "idle";
    QueryStatus["LOADING"] = "loading";
    QueryStatus["SUCCESS"] = "success";
    QueryStatus["ERROR"] = "error";
})(QueryStatus || (QueryStatus = {}));
export const deriveStatus = ({ status, fetchStatus }) => {
    if ((status === "pending" && fetchStatus !== "idle") ||
        fetchStatus === "fetching") {
        return QueryStatus.LOADING;
    }
    if (status === "success") {
        return QueryStatus.SUCCESS;
    }
    if (status === "error") {
        return QueryStatus.ERROR;
    }
    return QueryStatus.IDLE;
};
